import { UPDATE_ALL_CALLS } from '../actions';

const initialState = {};

export default function allCallsReducer(state, action) {
    //initialize state if its undef
    if (typeof state === 'undefined') {
        return initialState
    }
    switch (action.type) {
        case UPDATE_ALL_CALLS:

            if (!state[action.update.server]) {
                state[action.update.server] = [];
            }

            state[action.update.server] = [...action.update.all_calls];

            state = JSON.parse(JSON.stringify(state));
            break;
        default:
            break;
    }

    return state
}